export const timepicker = {
  width: '125px',
  position: 'absolute',
  right: 0,
  marginTop: 'xs',
  padding: 's',
  borderRadius: '5px',
  boxShadow: 'rgba(0, 0, 0, 0.4) 0px 0px 16px 0px',
  variants: {
    primary: {
      backgroundColor: 'rgb(27, 33, 41)',
      color: 'white',
    },
    secondary: {
      background: 'grey',
      color: 'white',
    },
  },
};

export const timepickerSelector = {
  states: {
    '&:hover': {
      background: 'rgb(25, 126, 247)',
    },
  },
};
